export const getNewLineItemsRequested = (lineItems, newItems = []) => {
  const filteredLineItems = lineItems
    .filter(item => item.exchanged_for_item || item.exchange_info)
    .map(item =>
      item.exchanged_for_item
        ? {
            ...item.exchanged_for_item,
            cancelled_from_draft: item?.exchanged_for_item?.cancelled_from_draft || item.cancelled_from_draft,
          }
        : { exchange_info: item.exchange_info, cancelled_from_draft: item.cancelled_from_draft }
    )
  return [...filteredLineItems, ...newItems]
}
